import { useEffect, useRef } from "react";
import BaseDialog from "../modelDialogs/BaseDialog";
import { itx } from "../translationItx/itx";

import Logger from "../Logger";
import { missingTexts } from "../translationItx/debugTextTranslation";
import { noItx, missingKeys } from "../translationItx/itx";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import WatchableValue from "../models/WatchableValue";

const logger = new Logger();

let debugTmp: any = {};
let lastRes: any = {};
let lastCode = "";

const resultText = new WatchableValue<string>("");

export default function Debug() {
  const refTextArea = useRef<HTMLTextAreaElement>(null);
  const refResultArea = useRef<HTMLTextAreaElement>(null);

  useOnChangeWatcher(resultText);

  useOnChangeWatcher(state.selectionManager, () => {
    doEval();
    return false;
  });

  useEffect(() => {
    if (refTextArea.current) {
      refTextArea.current.value = lastCode;
    }
  }, []);

  function downloadMissingKeysAndTextsTranslation() {
    const link = document.createElement("a");
    let content = `Missing keys: 
    `;
    missingKeys.forEach((key) => {
      content =
        content +
        key +
        ` 
      `;
    });
    content =
      content +
      `---------------------------------------------------------------------------------
      Missing texts: 
    `;
    missingTexts.forEach((key) => {
      content =
        content +
        key +
        ` 
      `;
    });

    const file = new Blob([content], { type: "text/plain" });
    link.href = URL.createObjectURL(file);
    link.download = `missingKeysAndTexts.txt`;

    link.click();
    URL.revokeObjectURL(link.href);
  }

  function evalInContext_Debug(code: string): any {
    const functionString = `
        return ${code}
     `;

    function output() {
      console.log(...arguments);
      let s = "";
      for (let i in arguments) {
        const a = arguments[i];
        if (typeof a == "object") {
          s += `Object: \n`;
          for (let j in a) {
            s += `${j}: ${a[j]} \n`;
          }
        } else {
          s += `${a}`;
        }
        s += " ";
      }
      s += "\n";

      resultText.value = resultText.value + s;
    }

    try {
      resultText.value = "";

      const myFunction = new Function("output", "obj", "state", "tmp", "res", functionString); // no itx
      const res = myFunction(output, state.selectionManager.selectedObject, state, debugTmp, lastRes);

      debugTmp.res = res;
      lastRes = res;

      if (res === undefined) {
        resultText.value = "undefined" + "\n"; // no itx
      } else if (typeof res == "object") {
        resultText.value = resultText.value + "\n" + JSON.stringify(res, null, 2);
      } else if (res === "") {
        resultText.value = '""' + "\n"; // no itx
      } else {
        resultText.value = resultText.value + "\n" + res;
      }
    } catch (ex: any) {
      const sError = `Eval Error : ${ex.message} \n`;

      logger.error(sError);
      alert(sError);
    }
  }

  function doEval1(s: string) {
    if (refResultArea.current) {
      refResultArea.current.value = "";
    }
    evalInContext_Debug(s);
  }

  function doEval() {
    const s = refTextArea.current?.value;
    if (refResultArea.current) {
      refResultArea.current.value = "";
    }

    if (s) {
      lastCode = refTextArea.current.value;
      doEval1(s);
    }
  }

  return (
    <BaseDialog
      title={itx("debug.title", "Estada Debugger")}
      noOkButton={true}
      abortCaption={state.translate("close", "Schließen")}
      onClose={() => {
        return true;
      }}
    >
      <div style={{ alignSelf: "end", display: "flex", alignItems: "end" }}>
        <button className="button" onClick={downloadMissingKeysAndTextsTranslation}>
          {noItx("download missingKeys and Texts")}
        </button>
      </div>
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "500px",
          height: "100%",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", paddingBottom: "20px" }}>
          <span style={{ fontWeight: "bold" }}>{noItx("Examples:")}</span>
          {noItx(
            `output (obj.name) // name of the actuell selected object output (state.selectionManager.selectedObject.name) //the same`,
          )}
          <br />
          {noItx(`state.floors.asArray()[0].name = "xxx";`)}
          <br />
          {noItx(`tmp.a = obj; // "tmp" persists multiple debug runs`)}
        </div>

        <textarea style={{ width: "calc(100% - 20px)", minHeight: "150px" }} ref={refTextArea}></textarea>

        <button
          style={{ width: "100px", alignSelf: "flex-end", marginRight: "20px", marginBottom: "10px" }}
          className="button"
          onClick={() => doEval()}
        >
          {noItx("Eval")}
        </button>

        <textarea
          style={{ width: "calc(100% - 20px)", minHeight: "150px" }}
          ref={refResultArea}
          value={resultText.value}
          onChange={(e) => {}}
        />
      </div>
    </BaseDialog>
  );
}
